import { BasicExpression, Expression } from 'app/model/dataflow/expressionTypes';

export abstract class ModelValidatorBase {
    protected invalidExpressions: Map<BasicExpression, BasicExpression>;

    public constructor() {
        this.invalidExpressions = new Map<BasicExpression, BasicExpression>();
    }

    public visitStruct(expression: BasicExpression): void {
        // to be overwritten
    }

    public visitParameterRef(expression: BasicExpression): void {
        // to be overwritten
    }

    public visitParameterOperand(expression: BasicExpression): void {
        // to be overwritten
    }

    public visitColumnOperandRef(expression: BasicExpression): void {
        // to be overwritten
    }

    public visitColumnOperand(expression: BasicExpression): void {
        // to be overwritten
    }

    public visitTransientRef(expression: BasicExpression): void {
        // to be overwritten
    }

    public visitTransientOperand(expression: BasicExpression): void {
        // to be overwritten
    }

    public visitXor(expression: Expression): void {
        if ((expression.xor.leftExpression && this.invalidExpressions.get(expression.xor.leftExpression)) ||
            (expression.xor.rightExpression && this.invalidExpressions.get(expression.xor.rightExpression))) {
            this.invalidExpressions.set(expression, this.invalidExpressions.get(expression.xor.leftExpression) || this.invalidExpressions.get(expression.xor.rightExpression));
        }
    }

    public visitOr(expression: Expression): void {
        if ((expression.or.leftExpression && this.invalidExpressions.get(expression.or.leftExpression)) ||
            (expression.or.rightExpression && this.invalidExpressions.get(expression.or.rightExpression))) {
            this.invalidExpressions.set(expression, this.invalidExpressions.get(expression.or.leftExpression) || this.invalidExpressions.get(expression.or.rightExpression));
        }
    }

    public visitFunctionExpr(expression: Expression): void {
        const invalidChild = expression.functionExpression.children.find((child) => child && this.invalidExpressions.has(child));
        if (invalidChild) {
            this.invalidExpressions.set(expression, invalidChild);
        }
    }

    public visitArray(expression: BasicExpression): void {
        // to be overwritten
    }

    public visitArrayIndexer(expression: BasicExpression): void {
        // to be overwritten
    }

    public visitFieldSelector(expression: BasicExpression): void {
        // to be overwritten
    }

    public visitAnd(expression: Expression): void {
        if ((expression.and.leftExpression && this.invalidExpressions.get(expression.and.leftExpression)) ||
            (expression.and.rightExpression && this.invalidExpressions.get(expression.and.rightExpression))) {
            this.invalidExpressions.set(expression, this.invalidExpressions.get(expression.and.leftExpression) || this.invalidExpressions.get(expression.and.rightExpression));
        }
    }

    public visitAddMinus(expression: Expression): void {
        if ((expression.addMinus.leftExpression && this.invalidExpressions.get(expression.addMinus.leftExpression)) ||
            (expression.addMinus.rightExpression && this.invalidExpressions.get(expression.addMinus.rightExpression))) {
            this.invalidExpressions.set(expression, this.invalidExpressions.get(expression.addMinus.leftExpression) || this.invalidExpressions.get(expression.addMinus.rightExpression));
        }
    }

    public visitLiteralExpr(expression: BasicExpression): void {
        // to be overwritten
    }

    public visitMetaVariableRef(expression: BasicExpression): void {
        // to be overwritten
    }

    public visitMetaMatchRef(expression: BasicExpression): void {
        // to be overwritten
    }

    public visitComparison(expression: Expression): void {
        if ((expression.comparison.leftExpression && this.invalidExpressions.get(expression.comparison.leftExpression)) ||
            (expression.comparison.rightExpression && this.invalidExpressions.get(expression.comparison.rightExpression))) {
            this.invalidExpressions.set(expression, this.invalidExpressions.get(expression.comparison.leftExpression) || this.invalidExpressions.get(expression.comparison.rightExpression));
        }
    }

    public visitScope(expression: Expression): void {
        if (this.invalidExpressions.has(expression.scope.expression)) {
            this.invalidExpressions.set(expression, expression.scope.expression);
        }
    }

    public visitEqNotEq(expression: Expression): void {
        if ((expression.eqNotEq.leftExpression && this.invalidExpressions.get(expression.eqNotEq.leftExpression)) ||
            (expression.eqNotEq.rightExpression && this.invalidExpressions.get(expression.eqNotEq.rightExpression))) {
            this.invalidExpressions.set(expression, this.invalidExpressions.get(expression.eqNotEq.leftExpression) || this.invalidExpressions.get(expression.eqNotEq.rightExpression));
        }
    }

    public visitMulDivMod(expression: Expression): void {
        if ((expression.mulDivMod.leftExpression && this.invalidExpressions.get(expression.mulDivMod.leftExpression)) ||
            (expression.mulDivMod.rightExpression && this.invalidExpressions.get(expression.mulDivMod.rightExpression))) {
            this.invalidExpressions.set(expression, this.invalidExpressions.get(expression.mulDivMod.leftExpression) || this.invalidExpressions.get(expression.mulDivMod.rightExpression));
        }
    }

    public visitMetaFunctionExpr(expression: Expression): void {
        const invalidChild = expression.metafunction.children.find((child) => child && this.invalidExpressions.has(child));
        if (invalidChild) {
            this.invalidExpressions.set(expression, invalidChild);
        }
    }

    public visitTransformFunctionExpr(expression: Expression): void {
        const invalidChild = expression.transformFunction.children.find((child) => child && this.invalidExpressions.has(child));
        if (invalidChild) {
            this.invalidExpressions.set(expression, invalidChild);
        }
    }

    public visitUnaryMinus(expression: Expression): void {
        if (this.invalidExpressions.has(expression.unaryMinus.expression)) {
            this.invalidExpressions.set(expression, expression.unaryMinus.expression);
        }
    }

    public visitNot(expression: Expression): void {
        if (this.invalidExpressions.has(expression.not.expression)) {
            this.invalidExpressions.set(expression, expression.not.expression);
        }
    }

    public getInvalidExpression(expression: BasicExpression): BasicExpression {
        return this.invalidExpressions.get(expression);
    }

    public getErrorMessage(expression: BasicExpression): string {
        return undefined;
    }
}
